import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-booking-details-holder',
  templateUrl: './booking-details-holder.component.html',
  styleUrls: ['./booking-details-holder.component.scss']
})
export class BookingDetailsHolderComponent implements OnInit {

  @Input() bookingData;
  @Input() popUpPosition;
  @Input() timeZone;
  @Input() bookingDisplaySeat;
  @Input() bookingPopUpDirection;
  @Input() openedFrom;
  @Input() selectedSearchInfo;
  @Input() selectedSearchSeat;
  @Input() seatStatus;
  @Input() isSeatClicked;
  @Output() closeEmitter = new EventEmitter();
  xPos = 100;
  yPos = 100;
  displayData: any = [];
  isBlockedSeat: boolean = false;
  isSlideIn: boolean = false;
  constructor() { }

  ngOnInit(): void {
    if (this.bookingData && (this.bookingData[0] && this.bookingData[0].timezone)) {
      this.timeZone = this.bookingData[0].timezone
    }
    this.isSlideIn=this.openedFrom!=='web'? true:false;
  }

  ngOnChanges() {
    if (this.bookingData && (this.bookingData[0] === "Blocked seat") && this.isSeatClicked) {
      this.isBlockedSeat = true;
    } else if(this.bookingData && this.isSeatClicked) {
      this.isBlockedSeat = false;
      this.displayData = [];
      Object.keys(this.bookingData).forEach((key) => {
        this.displayData.push(this.bookingData[key])
      })
    }
    let xDir = this.bookingPopUpDirection?12:-12;
    this.xPos = this.popUpPosition.xPos + xDir;
    this.yPos = this.popUpPosition.yPos;
  }

  getStatusColor(detail) {
    if (detail.seatStatus === 'BOOKED' || detail.seatStatus === 'OCCUPIED') {
      return '#38af49';
    } else {
      return '#ffdd49';
    }
  }

  close(event) {
    this.isSlideIn=false;
    if (event)
      event.stopPropagation();
    this.closeEmitter.emit(event)
  }
}
